export default "__VITE_ASSET__Vk6iqHg8__"